// extracted by mini-css-extract-plugin
export default {"socialButton":"socialButton__BeQZn"};